export default [
  {
    label: 'Üzemeltetés',
    type: 'heading',
  },
  {
    to: { name: 'Home' },
    label: 'Főoldal',
    icon: 'mdi-home'
  },
  {
    to: { name: 'CardOwnerList' },
    label: 'Kártyabirtokosok',
    right: 'CARD_OWNER',
    icon: 'mdi-account-multiple',
  },
  {
    to: { name: 'CardList' },
    label: 'Kártyák',
    right: 'CARD',
    icon: 'mdi-badge-account-horizontal',
  },
  {
    to: { name: 'GuestLogList' },
    label: 'Vendégbelépések',
    right: 'GUEST_LOG_READ',
    icon: 'mdi-account-edit',
  },
  {
    label: 'QR kódok',
    right: 'QR',
    icon: 'mdi-qrcode',
    group: 'QrCodes',
    children: [
      {
        to: { name: 'QrCodeRequestList' },
        label: 'Igénylés',
        right: 'QR_REQUEST',
        icon: 'mdi-plus',
      },
      {
        to: { name: 'QrCodeApprovalList' },
        label: 'Jóváhagyás',
        right: 'QR_APPROVAL',
        icon: 'mdi-check',
      },
      {
        to: { name: 'QrCodeList' },
        label: 'Lista',
        right: 'QR_READ',
        icon: 'mdi-format-list-bulleted',
      }
    ]
  },
  {
    to: { name: 'RemoteOpen' },
    right: 'REMOTE_OPEN',
    label: 'Távoli nyitás',
    icon: 'mdi-remote',
  },
  {
    label: 'Naplók',
    right: 'LOG_READ',
    icon: 'mdi-notebook-outline',
    group: 'Log',
    children: [
      {
        to: { name: 'AdminLog' },
        label: 'Admin napló',
        icon: 'mdi-shield-account-outline',
      },
      {
        to: { name: 'ParkingLog', params: { type: 'ParkingLot' } },
        label: 'Parkoló napló',
        icon: 'mdi-parking',
      },
      {
        to: { name: 'BuildingLog', params: { type: 'Building' } },
        label: 'Épület napló',
        icon: 'mdi-office-building',
      },
    ]
  },
  {
    to: { name: 'OccupantList' },
    right: 'OCCUPANT_LIST',
    label: 'Bentlévők listája',
    icon: 'mdi-account-details',
  },
  // {
  //   label: 'Kulcsok/Eszközök',
  //   right: 'KEY',
  //   icon: 'mdi-key-chain',
  //   group: 'Keys',
  //   children: [
  //     {
  //       to: { name: 'AssetList' },
  //       label: 'Lista',
  //       right: 'KEY',
  //       icon: 'mdi-format-list-bulleted',
  //     },
  //     {
  //       to: { name: 'AssetCabinetList' },
  //       label: 'Tárolók',
  //       right: 'KEY_READ',
  //       icon: 'mdi-file-cabinet',
  //     },
  //     {
  //       to: { name: 'AssetsLog' },
  //       label: 'Napló',
  //       right: 'KEY_READ',
  //       icon: 'mdi-notebook-outline',
  //     },
  //     {
  //       to: { name: 'AssetHandling' },
  //       label: 'Kiadás, visszavétel',
  //       right: 'KEY_HANDLING',
  //       icon: 'mdi-script-text-key',
  //     },
  //   ]
  // },
  {
    type: 'divider'
  },
  {
    label: 'Karbantartás',
    type: 'heading',
  },
  {
    label: 'Adminisztrátorok',
    right: 'USER',
    icon: 'mdi-account',
    group: 'Users',
    children: [
      {
        to: { name: 'UserList' },
        label: 'Lista',
        right: 'USER_READ',
        icon: 'mdi-format-list-bulleted',
      },
      {
        to: { name: 'NewUser' },
        label: 'Új',
        right: 'USER_WRITE',
        icon: 'mdi-plus',
      },
      {
        to: { name: 'Filter' },
        label: 'Szűrő',
        right: 'FILTER',
        icon: 'mdi-filter',
      }
    ]
  },
  {
    to: { name: 'GroupList' },
    label: 'Csoportok',
    right: 'GROUP_READ',
    icon: 'mdi-group',
  },
  {
    to: { name: 'ScheduleList' },
    label: 'Ütemzések',
    right: 'SCHEDULE_READ',
    icon: 'mdi-calendar-clock',
  },
  {
    to: { name: 'DateIntervalList' },
    label: 'Időszakok',
    right: 'SCHEDULE_READ',
    icon: 'mdi-calendar-multiple',
  },
  {
    to: { name: 'AccessLevelList' },
    label: 'Hozzáférési szintek',
    right: 'ACCESS_LEVEL_READ',
    icon: 'mdi-security',
  },
  {
    to: { name: 'OpeningHours' },
    label: 'Nyitvatartás',
    right: 'OPENING_READ',
    icon: 'mdi-timetable',
  },
  {
    label: 'Rendszerelemek',
    right: 'DEVICE_READ',
    icon: 'mdi-cog-outline',
    group: 'Devices',
    children: [
      {
        to: { name: 'BuildingList' },
        label: 'Épületek',
        icon: 'mdi-office-building',
        //            children: [
        //              {
        //                id: 'm611',
        //                link: '/building/edit',
        //                label: 'Épület módosítás',
        //                icon: '',
        //                parents: ['m6', 'm61'],
        //                level: 3
        //              }
        //            ]
      },
      // {
      //   to: { name: 'BuildingLevelList' },
      //   label: 'Szintek',
      //   icon: 'mdi-layers-triple-outline',
      // },
      // {
      //   to: { name: 'GatewayList' },
      //   label: 'Átjárók (szoftveres)',
      //   icon: 'mdi-router-network',
      // },
      {
        to: { name: 'ConnectionList' },
        label: 'Kapcsolatok',
        icon: 'mdi-connection',
      },
      {
        to: { name: 'ControllerList' },
        label: 'Kontrollerek',
        icon: 'mdi-chip',
      },
      {
        to: { name: 'ReaderList' },
        label: 'Olvasók',
        icon: 'mdi-smart-card-reader-outline',
      },
      // {
      //   to: { name: 'RelayList' },
      //   label: 'Relék',
      //   icon: 'mdi-doorbell',
      // },
      {
        to: { name: 'DoorList' },
        label: 'Ajtók',
        icon: 'mdi-door-closed',
      },
      {
        to: { name: 'BarrierList' },
        label: 'Sorompók',
        icon: 'mdi-boom-gate',
      },
      {
        to: { name: 'TurnstileList' },
        label: 'Forgóvillák',
        icon: 'mdi-turnstile-outline',
      },
      {
        to: { name: 'Cameras' },
        label: 'Kamerák',
        icon: 'mdi-cctv',
      },
      {
        to: { name: 'ZoneList' },
        label: 'Zónák',
        right: 'DEVICE_READ',
        icon: 'mdi-fence',
      },
    ],
  },
];
